import React from "react";

const ChillerVanFaq = ({ title, faqs }) => {
  return (
    <section className="cv-faq-section">
      <div className="container">
        <h2
          className="text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <div
          className="cv-faq-list"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          {faqs.map((faq, i) => (
            <div key={i} className="cv-faq-item">
              <h3>Q: {faq.q}</h3>
              <p>{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChillerVanFaq;
